import { announceSelectChange } from "#/shared/legacy/forms/manipulate-input.js";
import "#legacy/utilities/manipulate_input/base.js";

class ManipulateInputElement extends BaseManipulateInput {
  constructor(input) {
    super(input);
  }

  getValue() {
    return this.input.val();
  }

  setValue(value) {
    let valueWas = this.getValue();
    this.input.val(value);
    if (valueWas != this.getValue()) {
      this.onChange();
    }
  }

  onChange() {
    if (!announceSelectChange(this.input[0]) && this.input.closest(".uber_select").length) {
      this.input.trigger("uber-select:refresh");
    }
  }
}

window.ManipulateInputElement = ManipulateInputElement;
